// Import action types related to horoscope data
import {
  HOROSCOPE_ARE_LOADING,
  HOROSCOPE_FETCH_DATA_SUCCESS,
  HOROSCOPE_HAVE_ERROR,
} from "../actionType";

// Define the initial state for the HoroscopeReducer
const initialState = {
  data: [],
  loading: true,
  error: [], // Initialize error as null for better error handling
};

// Reducer function to handle horoscope-related actions and update state accordingly
export function HoroscopeReducer(state = initialState, action) {
  switch (action.type) {
    // Handle error case when fetching horoscope data
    case HOROSCOPE_HAVE_ERROR:
      return {
        ...state,
        error: action.hasError, // Update the error state with the error from the action
        loading: false, // Set loading to false since the request is complete
      };

    // Handle loading state when horoscope data is being fetched
    case HOROSCOPE_ARE_LOADING:
      return {
        ...state,
        loading: action.isLoading, // Update the loading state with the loading status from the action
      };

    // Handle success case when horoscope data is successfully fetched
    case HOROSCOPE_FETCH_DATA_SUCCESS:
      return {
        ...state,
        data: action.horoscope, // Update the data state with the fetched horoscope data
        loading: false, // Set loading to false since the request is complete
        error: null, // Clear any previous errors
      };

    // Return the current state by default if action type is not recognized
    default:
      return state;
  }
}
